import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsAgendas = (areaId, years = null) => {
  let endpoint = `/wts/agenda/cursoAgenda?area=${areaId}`;

  if (years) {
    const yearsQuery = Array.isArray(years) ? years.join(',') : years;
    endpoint += `&years=${yearsQuery}`;
  }

  return apiActionCreator({
    'endpoint': endpoint,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_WTS_AGENDAS,
      ActionTypes.FETCHED_WTS_AGENDAS,
      [
        ActionTypes.FETCHED_WTS_AGENDAS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const createWtsAgenda = (areaId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/agenda/cursoAgenda',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_AGENDA,
        [
          () => {
            dispatch(getWtsAgendas(areaId));
            return {'type': ActionTypes.CREATED_WTS_AGENDA};
          },
          MessageActions.addMessageBoxInfo('Curso de agenda creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_AGENDA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsAgenda = (areaId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/agenda/cursoAgenda',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_AGENDA,
        [
          () => {
            dispatch(getWtsAgendas(areaId));
            return {'type': ActionTypes.UPDATED_WTS_AGENDA};
          },
          MessageActions.addMessageBoxInfo('Curso de agenda actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_AGENDA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': {
        ...data,
        'id_area': areaId,
      },
    })
  );
};

export const deleteWtsAgenda = (areaId, agendaId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/agenda/cursoAgenda?id=${agendaId}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_WTS_AGENDA,
        [
          () => {
            dispatch(getWtsAgendas(areaId));
            return {'type': ActionTypes.DELETED_WTS_AGENDA};
          },
          MessageActions.addMessageBoxInfo('Curso de agenda eliminado satisfactoriamente'),
        ],
        [
          ActionTypes.DELETED_WTS_AGENDA_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};

export const getWtsAgendaLastId = (areaId) => apiActionCreator({
  'endpoint': `/wts/agenda/cursoAgenda?area=${areaId}&last_id=true`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_AGENDA_LAST_ID,
    ActionTypes.FETCHED_WTS_AGENDA_LAST_ID,
    [
      ActionTypes.FETCHED_WTS_AGENDA_LAST_ID_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
